import getUserSettings from '../containers/with-user-settings/query.graphql'

const typeDefs = `
  type UserSettings {
    browseStoresView: String!,
  }

  type Mutation {
    updateUserSettings(userSettings: UserSettings!): UserSettings
  }
`

const UserSettings = {
  typeDefs,
  resolvers: {
    Mutation: {
      updateUserSettings: (_, { userSettings }, { cache }) => {
        const previousUserSettings = cache.readQuery({
          query: getUserSettings,
        })
        const newSettings = {
          ...previousUserSettings,
          ...userSettings,
        }
        const data = {
          userSettings: {
            __typename: 'UserSettings',
            ...newSettings,
          },
        }

        cache.writeData({ data })

        return newSettings
      },
    },
  },
  __typename: 'UserSettings',
  defaults: {
    browseStoresView: 'grid',
  },
}

export default UserSettings
